<template>
    <the-header></the-header>
    <router-view></router-view>
</template>

<script>
import data from './assets/data.json';
import { mapActions } from 'vuex';
import TheHeader from './components/TheHeader.vue';
export default {
    components: {
        TheHeader
    },

    created() {
        addEventListener('resize', () => {
            this.updateScreenWidth(window.innerWidth);
        });
        this.updateScreenWidth(window.innerWidth);

        this.uploadPlanetsData(data);
    },

    methods: {
        ...mapActions(['updateScreenWidth', 'uploadPlanetsData'])
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Antonio:wght@100..700&family=League+Spartan:wght@100..900&display=swap');
*{ 
    box-sizing: border-box;
}
html {
    font-family: "Antonio", sans-serif;
    color: #FFF;
    height: 100%;
    background-image: url('/src/assets/background-stars.svg');
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #070724;
}

body {
    margin: 0;
}
</style>